// extracted by mini-css-extract-plugin
export default {"themeToggle":"U6fzlLTHO36op2AvSqak"};